import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function ResourceManagerResourceSelect(props) {
  const {
    value,
    onHandleChange,
    className = "",
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [resources, setResources] = useState();

  // > LOAD RESOURCES //
  const loadResources = useCallback(
    async () =>
      axios
        .post(axiosPath("api_r_user_module_resourceManager_getResources"), {
          moduleBridgeHex,
        })
        .then(({ data }) => {
          if (isMounted.current) setResources(data);
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex]
  );

  useEffect(() => {
    loadResources();
  }, []);
  // < LOAD RESOURCES //

  return (
    <AppMultiSelect
      options={resources}
      title={ReactDOMServer.renderToString(
        <Translator file="module-resourceManager" name="resource.resources" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-resourceManager"
          name="select.one.or.multiple.resources"
        />
      )}
      value={value}
      onChange={onHandleChange}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      className={className}
      isLoading={!resources}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
